export default "__VITE_PUBLIC_ASSET__269bc736__"